import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Textarea } from '../../../../../CommonComponents/OPL/Textarea/Textarea';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormFieldName as FirmFormFieldName } from '../../FirmSettings.meta';
import { FormFieldName as MySettingsFormFieldName } from '../../../MySettings/MySettings.meta';

interface Props extends MarginProps {
  isFirm?: boolean;
  fieldName: FirmFormFieldName | MySettingsFormFieldName;
  formBag: UseFormReturn<any>;
}

export const TermsAndConditions: React.FC<Props> = ({ isFirm, fieldName, formBag, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Client Terms and Conditions" />

      <Textarea
        {...formBag.register(fieldName)}
        rows={8}
        placeholder="Enter custom terms and conditions"
        maxLength={36000}
        resize="vertical"
        aria-label="Client Terms and Conditions"
        helperText="Max. 36,000 characters"
      />

      {isFirm && (
        <Toggle {...formBag.register('allowAdvisersCustomTermsAndConditions')} mt="24">
          Allow Advisors to Override Client Terms and Conditions
        </Toggle>
      )}
    </Box>
  );
};
